
import { Box, Button, IconButton } from "@mui/material";
import { DataGridPremium, GridToolbarContainer, useGridApiRef } from "@mui/x-data-grid-premium";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import strings from "../../Globalization/index";

const objectIdPattern = /^[0-9a-fA-F]{24}$/;

const QuickSearchForm = ({ activeRecord = {}, formik = {} }) => {
	const apiRef = useGridApiRef();
	const [state, setState] = useState({
		isRefreshGrid: false,
		selectedRow: '',
		newRowId: null
	})
	const { record = {} } = activeRecord
	const cellInEditRef = useRef(null)
	useEffect(() => {
		if (state.newRowId !== null) {
			const timer = setTimeout(() => {
				setState({ ...state, newRowId: null })
			}, 500);
			return () => clearTimeout(timer);
		}
	}, [state.newRowId])


	const setValueSetter = (value, row) => {
		if (cellInEditRef.current) {
			cellInEditRef.current.value = value;
		}
		return row;
	};

	const quickSearchColumns = [
		{
			headerName: strings.ScopeName,
			field: "ScopeName",
			width: 400,
			editable: true,
			valueSetter: setValueSetter
		},
		{
			headerName: strings.SerialNumberSecond,
			field: "SerialNumber",
			width: 400,
			editable: true,
			valueSetter: setValueSetter
		},
		{
			field: 'actions',
			type: 'actions',
			headerName: strings.Remove,
			width: 100,
			renderCell: ({ id, row }) => {
				return (
					<IconButton
						color="error"
						onClick={() => handleRemove({ id, row })}
						disabled={record?.ScopeDetails?.length === 1 || objectIdPattern.test(row.id)}
					>
						<DeleteIcon />
					</IconButton>
				);
			}
		}
	];
	const rows = useMemo(() => {
		const scopeDetails = activeRecord?.record?.ScopeDetails || [];
		return scopeDetails.map((data, index) => ({
			...data,
			id: data?.id || index + 1
		}));
	}, [activeRecord?.record?.ScopeDetails, state.isRefreshGrid]);

	const getClassNames = (params) => {
		if (params.id === state.newRowId) {
			return 'row-class-blue';
		}
		return '';
	};
	const CustomeToolBar = () => {
		const handleAddRow = () => {
			const length = record?.ScopeDetails.length;
			const calIndex = length + 1;
			const scopeName = `${record?.ManufacturerName} ${record?.ScopeType} ${calIndex}` // Createing ScopeName
			const newRow = { id: calIndex, ScopeName: scopeName, SerialNumber: ``, isNew: true }; // Adding new Row
			apiRef?.current?.updateRows([newRow]); // updateing the row
			activeRecord.record.ScopeDetails = [...activeRecord.record.ScopeDetails, newRow]; // Adding the new row data in activeRecord
			formik.setFieldValue('ScopeDetails', activeRecord.record.ScopeDetails); //updating formik vlaue
			setState({ ...state, newRowId: newRow.id, isRefreshGrid: !state.isRefreshGrid }) // Refreshing grid data
		};

		return (
			<GridToolbarContainer sx={{ justifyContent: 'flex-start' }}>
				<Button onClick={handleAddRow} variant="contained" color="success" startIcon={<AddIcon fontSize="inherit" />}>{strings.Add}</Button>
			</GridToolbarContainer>
		);
	};

	const onCellEditStop = () => {
		const { index, field, value } = cellInEditRef.current;
		record.ScopeDetails[index][field] = value
		formik.setFieldValue('ScopeDetails', record?.ScopeDetails);
		setState({ ...state, isRefreshGrid: !state.isRefreshGrid });
		cellInEditRef.current = null

	}
	const onCellEditStart = ({ colDef, row }) => {
		// calculating the index based on the index the scopeName
		const index = record.ScopeDetails.findIndex(rec => rec.ScopeName === row.ScopeName)
		cellInEditRef.current = { field: colDef.field, index }
	}

	const handleRemove = useCallback(({ row }) => {
		const actualScopes = activeRecord.record?.ScopeDetails?.filter(data => data.ScopeName !== row.ScopeName);
		const removeValue = activeRecord.record?.RemoveScopes?.concat(activeRecord.record?.ScopeDetails?.filter(data => data.ScopeName === row.ScopeName)[0].id);
		activeRecord.record.ScopeDetails = actualScopes;
		activeRecord.record.RemoveScopes = removeValue; // Assign the updated ids of removeScopes
		formik.setFieldValue('ScopeDetails', actualScopes);
		formik.setFieldValue('RemoveScopes', removeValue);// updating the formik values
		setState({ ...state, isRefreshGrid: !state.isRefreshGrid }); //refreshing the grid data
	}, [])
	return (
		<Box sx={{
			width: '100%',
			height: 400,
		}}>
			<DataGridPremium
				columns={quickSearchColumns}
				rows={rows}
				getRowClassName={getClassNames}
				onRowSelectionModelChange={(index) => setState({ ...state, selectedRow: index })}
				apiRef={apiRef}
				sx={{ border: "none", textDecoration: "", marginTop: '100px', marginLeft: '20px' }}
				slots={{
					toolbar: CustomeToolBar,
				}}
				showToolbar
				onCellEditStart={onCellEditStart}
				onCellEditStop={onCellEditStop}
				editMode="cell"
				disableColumnMenu
			/>
		</Box>
	)
}

export default QuickSearchForm;